var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.src)?_c('BaseImage',{attrs:{"src":_vm.src,"alt":_vm.alt,"loading":_vm.loading,"image-tag":"nuxt-img","nuxt-img-config":_vm.nuxtImgConfig,"preload":_vm.preload}}):_c('BaseImage',{staticClass:"storyblokImage",attrs:{"src":_vm.placeholder,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }